import { useMutation, useQueryClient } from "@tanstack/react-query"
import { deleteDraw } from "../../services/draw"
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useDeleteDraw = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteDraw,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['draws'] });
            indicators.setIsProcessRunning(false);
            toast.success('Draw deleted successfully!');
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
            indicators.setIsServiceError(error?.response?.data?.message);
        }
    });
};

export default useDeleteDraw;